import classnames from 'classnames'
import moment from 'moment'
import PropTypes from 'prop-types'
import Calendar from 'rc-calendar'
import esES from 'rc-calendar/lib/locale/es_ES'
import DatePicker from 'rc-calendar/lib/Picker'
import { PureComponent } from 'react'

import Chip from '../Chip'
import Icon from '../Icon'

import styles from './index.css'

const DEFAULT_END_DATE = moment()
const DEFAULT_START_DATE = moment().add(-1, 'months')

const createCalendar = (defaultValue, disabledDate) => (
  <Calendar defaultValue={defaultValue} disabledDate={disabledDate} locale={esES} showDateInput={false} />
)

export const isDisabledDate = (startDate, endDate) => endDate && startDate && endDate.diff(startDate, 'days') <= 0

class DateRangePicker extends PureComponent {
  disabledEndDate = (endDate) => isDisabledDate(this.props.startDate, endDate)

  disabledStartDate = (startDate) => isDisabledDate(startDate, this.props.endDate)

  onChangeEndDate = (endDate) => this.props.onChange(this.props.startDate, endDate)

  onChangeStartDate = (startDate) => this.props.onChange(startDate, this.props.endDate)

  render() {
    const { className, endDate, startDate } = this.props
    const endCalendar = createCalendar(DEFAULT_END_DATE, this.disabledEndDate)
    const startCalendar = createCalendar(DEFAULT_START_DATE, this.disabledStartDate)

    return (
      <div className={classnames(className, styles.wrapper)}>
        <DatePicker animation="slide-up" calendar={startCalendar} onChange={this.onChangeStartDate} value={startDate}>
          {({ value }) => (
            <Chip ariaLabel={`Fecha inicial: ${value.format('ddd, DD [de] MMM YYYY')}`}>
              {value.format('ddd, DD [de] MMM YYYY')}
            </Chip>
          )}
        </DatePicker>
        <Icon className={styles.icon} name="calendar" />
        <DatePicker animation="slide-up" calendar={endCalendar} onChange={this.onChangeEndDate} value={endDate}>
          {({ value }) => (
            <Chip ariaLabel={`Fecha final: ${value.format('ddd, DD [de] MMM YYYY')}`}>
              {value.format('ddd, DD [de] MMM YYYY')}
            </Chip>
          )}
        </DatePicker>
      </div>
    )
  }
}

DateRangePicker.propTypes = {
  onChange: PropTypes.func.isRequired,

  className: PropTypes.string,
  endDate: PropTypes.instanceOf(moment),
  startDate: PropTypes.instanceOf(moment),
}

DateRangePicker.defaultProps = {
  className: '',
  endDate: DEFAULT_END_DATE,
  startDate: DEFAULT_START_DATE,
}

export default DateRangePicker
